export default {
  namespaced: true,
  inventory_equipment_type_catalog: {
    menu: "Catálogo de Tipos de Equipo",
    title: "Tipo de Equipo",
    name: "Nombre",
    created_at: "Creado",
    updated_at: "Actualizado",
  },
};
